import gql from 'graphql-tag';

export default gql`
  fragment projectGroupPreleadCustomizeItemFragment on ProjectGroupPreleadCustomizeItem {
    id
    name
    dataType
    dataTypeText
    position
    isDisplay
    isDeleted
    selectOptions {
      id
      label
    }
  }
`;
